































































































































































import Vue from "vue";
import { Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import { NavBar, Col, Row, Image as VanImage, Icon } from "vant";
Vue.use(NavBar);
Vue.use(Col);
Vue.use(Row);
Vue.use(VanImage);
Vue.use(Icon);

@Component
export default class HealthAdvisory extends Vue {
  onClickLeft() {
    this.$router.back();
  }
  goCard() {
    this.$router.push("/manCard");
  }
  goCardW() {
    this.$router.push("/manCard_wrs");
  }
  goCardZ() {
    this.$router.push("/manCard_zxq");
  }
}
